import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.date.to-json.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
/*
    GA Enhanced ECommerce API integration

    ******************************
    USE CASE EXAMPLE: LTD checkout process
    ******************************

    1. user navigate to product page, i.e. ltd
        onProductView:
            ga('ec:addProduct', product)  // product.packages ? => product.price == 0
            ga('ec:setAction', 'detail')
            ga('send', 'event', 'ProductDetails', 'click', product.id);

    2. user navigate to checkout page with packages

    3. user view step: packages

    4. user select package
        onProductAdd:
            ga('ec:addProduct', product w/package variant)
            ga('ec:setAction', 'add')
            ga('send', 'event', 'CheckoutPackageAdd', 'click', package.id)
        onProductRemove:
            ga('ec:addProduct', product w/package variant)
            ga('ec:setAction', 'remove')
            ga('send', 'event', 'CheckoutPackageRemove', 'click', previousPackage.id)

    5. user view step: cart review + options
         onCartReviewLoad:
            ga('ec:addProduct', product w/package)
            ga('ec:setAction','checkout', {
                'step': 1
            });
            ga('set', 'page', '/checkout/ltd/1')
            ga('send', 'pageview')

    6. user add/remove options
        onOptionAdd:
            ga('ec:addProduct', option)
            ga('ec:setAction', 'add')
            ga('send', 'event', 'CheckoutOptionAdd', 'click', option.id)
        onOptionRemove:
            ga('ec:addProduct', option)
            ga('ec:setAction', 'remove')
            ga('send', 'event', 'CheckoutOptionRemove', 'click', option.id)

    7. user click checkout> btn

    8. user view step: payment details
        onPaymentDetailsLoad:
            ga('ec:addProduct', product w/package w/options)
            ga('ec:setAction','checkout', {
                'step': 2
            });
            ga('set', 'page', '/checkout/ltd/2')
            ga('send', 'pageview')

    9. user redirected to dashboard
        onPurchased:
            ga('ec:addProduct', product+package+options)
            ga('ec:setAction', 'purchase', orderData);
            ga('send', 'event', 'Checkout', 'view', 'purchase')
 */

var GAEECommerce = {
  ec_productModel: {
    'id': null,
    // 'P12345',
    'name': null,
    // 'Android Warhol T-Shirt',
    'category': null,
    // 'Apparel',
    'brand': null,
    // 'Google',
    'variant': null,
    // 'black',
    'price': null,
    // '29.20',
    'quantity': 1
  },
  ec_purchaseModel: {
    'id': null,
    // 'T12345',
    'affiliation': null,
    // 'Google Store - Online',
    'revenue': 0,
    // '37.39',
    'tax': 0,
    // '2.85',
    'shipping': 0,
    // '5.34',
    'coupon': null // 'SUMMER2013'
  },
  isPageSet: false,
  initialize: function initialize() {
    if (!window.ga) this.initGA();
    ga('require', 'ec');
    ga('set', 'currencyCode', 'GBP');
  },
  setPageName: function setPageName(pageName) {
    ga('set', 'page', pageName);
  },
  clear: function clear() {
    var previousProduct = this.localStorage_read('GAEECommerce.product');
    if (previousProduct) this.onProductRemove(previousProduct);
    var self = this;
    var options = this.localStorage_read('GAEECommerce.options');
    if (options) options.forEach(function (o) {
      self.onOptionRemove(o);
    });
  },
  onProductView: function onProductView(product) {
    ga('ec:addProduct', product);
    ga('ec:setAction', 'detail');
    ga('send', 'event', 'ProductDetails', 'click', product.id);
  },
  onProductAdd: function onProductAdd(product) {
    ga('ec:addProduct', product);
    ga('ec:setAction', 'add');
    ga('send', 'event', 'CheckoutProductAdd', 'click', product.id);
    this.localStorage_write('GAEECommerce.product', product);
  },
  onProductRemove: function onProductRemove(product) {
    ga('ec:addProduct', product);
    ga('ec:setAction', 'remove');
    ga('send', 'event', 'CheckoutProductRemove', 'click', product.id);
    this.localStorage_remove('GAEECommerce.product');
  },
  onPackageViewLoad: function onPackageViewLoad(productId) {
    ga('set', 'page', '/checkout/' + productId + '/0');
    ga('send', 'pageview');
  },
  onCartReviewLoad: function onCartReviewLoad(product) {
    // exactly 1 product in the cart here
    product = typeof product != 'undefined' && product ? product : this.localStorage_read('GAEECommerce.product');
    if (product) {
      ga('ec:addProduct', product);
      ga('ec:setAction', 'checkout', {
        'step': 1
      });
      ga('set', 'page', '/checkout/' + product.id + '/1');
      ga('send', 'pageview');
    }
  },
  onOptionAdd: function onOptionAdd(option) {
    ga('ec:addProduct', option);
    ga('ec:setAction', 'add');
    ga('send', 'event', 'CheckoutOptionAdd', 'click', option.id);
    var options = this.localStorage_read('GAEECommerce.options');
    if (!options) options = [];
    options.push(option);
    this.localStorage_write('GAEECommerce.options', options);
  },
  onOptionRemove: function onOptionRemove(option) {
    ga('ec:addProduct', option);
    ga('ec:setAction', 'remove');
    ga('send', 'event', 'CheckoutOptionRemove', 'click', option.id);
    var options = this.localStorage_read('GAEECommerce.options');
    if (!options) options = [];
    for (var i = 0; i < options.length; i++) if (options[i].id === option.id) break;
    if (i < options.length && options[i]) options.splice(i, 1);
    this.localStorage_write('GAEECommerce.options', options);
  },
  onPaymentDetailsLoad: function onPaymentDetailsLoad() {
    // with products w/ product&package
    var product = this.localStorage_read('GAEECommerce.product');
    ga('ec:addProduct', product);

    // w/ options
    var options = this.localStorage_read('GAEECommerce.options');
    if (options) options.forEach(function (o) {
      ga('ec:addProduct', o);
    });
    ga('ec:setAction', 'checkout', {
      'step': 2
    });
    ga('set', 'page', '/checkout/' + product.id + '/2');
    ga('send', 'pageview');
  },
  onPurchase: function onPurchase(pageName, purchase) {
    // with products w/ product&package
    var product = this.localStorage_read('GAEECommerce.product');
    ga('ec:addProduct', product);

    // w/ options
    var options = this.localStorage_read('GAEECommerce.options');
    if (options) options.forEach(function (o) {
      ga('ec:addProduct', o);
    });
    ga('ec:setAction', 'purchase', purchase);
    ga('set', 'page', pageName);
    ga('send', 'pageview');
  },
  initGA: function initGA() {
    (function (i, s, o, g, r, a, m) {
      i['GoogleAnalyticsObject'] = r;
      i[r] = i[r] || function () {
        (i[r].q = i[r].q || []).push(arguments);
      }, i[r].l = 1 * new Date();
      a = s.createElement(o), m = s.getElementsByTagName(o)[0];
      a.async = 1;
      a.src = g;
      m.parentNode.insertBefore(a, m);
    })(window, document, 'script', '//www.google-analytics.com/analytics.js', 'ga');
    ga('create', clientData.config.analytics.google, 'auto');
    ga('require', 'displayfeatures');
  },
  createECProduct: function createECProduct(type, item, clientData) {
    var res = $.extend({}, this.ec_productModel);
    var category = clientData.formData.type.replace('/forms', '').split('/');
    var id = category[category.length - 1];
    category.pop();
    var prodPrice = item.price;
    if (item.nonTaxableAmount) {
      // get the actual svc price w/o tax and w/o ch
      prodPrice = (prodPrice * (1 + 0.2) - item.nonTaxableAmount) / 1.2;
      prodPrice = parseFloat(prodPrice.toFixed(2));
    }
    switch (type) {
      case 'product':
        // ex: clientId
        res.id = id; // ltd
        res.name = item.name; // Limited company incorporation
        res.category = category.join('/'); // /company/creation/
        res.brand = clientData.config.app.brandName; // onlinefilings.co.uk
        // res.price = item.price * (1 + parseFloat(clientData.config.merchant.salesTax));
        // res.price = item.price;
        res.price = prodPrice;
        break;
      case 'option':
        res.id = item.id;
        res.name = item.title;
        res.category = category.join('/') + '/' + id;
        res.brand = clientData.config.app.brandName;
        // res.price = item.price;
        res.price = prodPrice;
        break;
    }
    return res;
  },
  createECPurchase: function createECPurchase(orderData) {
    var _clientData$sjData, _clientData$sjData2;
    var res = $.extend({}, this.ec_purchaseModel);
    res.id = orderData.paymentKey;
    res.affiliation = clientData.config.app.brandName;
    res.revenue = ((_clientData$sjData = clientData.sjData) === null || _clientData$sjData === void 0 || (_clientData$sjData = _clientData$sjData.topLevelService) === null || _clientData$sjData === void 0 ? void 0 : _clientData$sjData.withoutVat) || orderData.subTotal;
    res.tax = ((_clientData$sjData2 = clientData.sjData) === null || _clientData$sjData2 === void 0 || (_clientData$sjData2 = _clientData$sjData2.topLevelService) === null || _clientData$sjData2 === void 0 ? void 0 : _clientData$sjData2.vat) || orderData.tax;
    res.shipping = typeof orderData.shipping != 'undefined' ? orderData.shipping : 0;
    res.coupon = typeof orderData.coupon != 'undefined' ? orderData.coupon : null;
    return res;
  },
  localStorage_read: function localStorage_read(key) {
    var item = Utils.localStorage.getItem(key);
    if (item) try {
      return JSON.parse(item);
    } catch (ex) {
      return null;
    }
    return null;
  },
  localStorage_write: function localStorage_write(key, item) {
    Utils.localStorage.setItem(key, JSON.stringify(item));
  },
  localStorage_remove: function localStorage_remove(key) {
    Utils.localStorage.removeItem(key);
  },
  clearStorage: function clearStorage() {
    this.localStorage_remove('GAEECommerce.product');
    this.localStorage_remove('GAEECommerce.package');
    this.localStorage_remove('GAEECommerce.options');
  }
};
export { GAEECommerce };